import { Fragment, useEffect, useState, useRef, memo } from 'react';
import { Button, Layout, Card, Space, Form, Input, Skeleton, Tooltip, Row, Col, Tabs } from 'antd';
import DataTable from '../DataTable';
import './index.less';

const DataTab = ({ name, filObj, setFilObj }) => {
    const [choice, setcChoice] = useState('1');

    const onChice = key => {
        setcChoice(key);
        setFilObj({
            phone: '',
            durationBegin: '',
            durationEnd: '',
            submittedBegin: '',
            submittedEnd: '',
            channelId: '',
        });
    };
    // const onTabClick=()=>{
    //     console.log(1);

    // }
    return (
        <div>
            <Tabs
                defaultActiveKey="1"
                onChange={onChice}
                items={[
                    {
                        key: '1',
                        label: '有效数据',
                        children: <DataTable type={1} choice={choice} filObj={filObj} setFilObj={setFilObj} />,
                    },
                    {
                        key: '2',
                        label: '无效数据',
                        children: <DataTable type={2} choice={choice} filObj={filObj} setFilObj={setFilObj} />,
                    },
                ]}
            />
        </div>
    );
};

export default memo(DataTab);
